import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import styled from '../../../theme/theme';

interface StyledWrapperProps {
  isEmbeddedMobile: boolean;
}

export const StyledWrapper = styled(Wrapper)<StyledWrapperProps>({
  'th:first-child, td:first-child': {
    textAlign: 'left',
  },
});
